// extracted by mini-css-extract-plugin
module.exports = {"main":"moreDetails_main__1Zya9","title":"moreDetails_title__3ehoJ"};